import React, { useState } from 'react';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

const JidoLightbox = ({ jidoscenario }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [photoIndex, setPhotoIndex] = useState(0);

    // console.log("JidoLightbox")
    // console.log(jidoscenario)

    const openLightbox = (index) => {
        setIsOpen(true);
        setPhotoIndex(index);
    };

    const closeLightbox = () => {
        setIsOpen(false);
    };

    const images = jidoscenario.map((item) => item.image_jido);

    return (
        <div>
            <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-1">
                {jidoscenario.map((item, index) => (
                    <div key={index} className="flex justify-center">
                        <img
                            src={item.image_jido}
                            alt={`Image ${index}`}
                            className="max-w-full h-auto cursor-pointer"
                            onClick={() => openLightbox(index)}
                        />
                    </div>
                ))}
            </div>

            {isOpen && (
                <Lightbox
                    mainSrc={images[photoIndex]}
                    nextSrc={images[(photoIndex + 1) % images.length]}
                    prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                    onCloseRequest={closeLightbox}
                    onMovePrevRequest={() => setPhotoIndex((photoIndex + images.length - 1) % images.length)}
                    onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % images.length)}
                />
            )}
        </div>
    );
};

export default JidoLightbox;